import { render, staticRenderFns } from "./Pintura.vue?vue&type=template&id=e2b4e7d2&scoped=true&"
import script from "./Pintura.vue?vue&type=script&lang=js&"
export * from "./Pintura.vue?vue&type=script&lang=js&"
import style0 from "./Pintura.vue?vue&type=style&index=0&id=e2b4e7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b4e7d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
